export default "__VITE_ASSET__DBhBdwoG__"